export default "__VITE_ASSET__DipJYuCu__"